export default "/50f517735fec46580f19aae3e56e9fe21614ea75/b552ae94a3baa9664c4076d726380c66.svg";